import React from "react";
import { Box } from "@mui/material";

export interface DocumentTestTeam {
    id: string;
    userName: string;
    role: string;
    name: string;
    position: string;
    email: string;
    companyName: string;
}

interface PrintPreviewDocumentTestTeamProps {
    team: DocumentTestTeam[];
    lang?: string;
}

const T = (langRaw?: string | null) => {
    const v = langRaw?.toLowerCase();

    if (v === "pl") {
        return {
            lp: "Lp.",
            name: "Imię i nazwisko",
            position: "Stanowisko",
            role: "Rola",
            email: "Email",
            company: "Firma"
        };
    }

    return {
        lp: "No.",
        name: "Full name",
        position: "Position",
        role: "Role",
        email: "Email",
        company: "Company"
    };
};

function roleToLabel(role: string, lang: string) {
    const r = role?.toUpperCase();
    const l = lang?.toLowerCase();

    if (l === "pl") {
        switch (r) {
            case "TESTER":
                return "Tester";
            case "APPROVER":
                return "Zatwierdzający";
            default:
                return role;
        }
    }

    switch (r) {
        case "TESTER":
            return "Tester";
        case "APPROVER":
            return "Approver";
        default:
            return role;
    }
}


export const PrintPreviewDocumentTestTeam: React.FC<
    PrintPreviewDocumentTestTeamProps
> = ({ team, lang = "pl" }) => {
    const t = T(lang);
    const hasRows = (team?.length ?? 0) > 0;

    return (
        <Box
            sx={{
                backgroundColor: "#fff",
                p: 2,
                border: "1px solid #ddd",
                fontFamily: `Arial, "Helvetica Neue", Helvetica, sans-serif`,
                lineHeight: 1.6,
                color: "#000",
                "& section": { pageBreakInside: "avoid" },
                "& table": {
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: "16px",
                    pageBreakInside: "avoid",
                },
                "& th, & td": {
                    border: "1px solid #000",
                    padding: "6px 8px",
                    verticalAlign: "top",
                    fontSize: "0.9rem",
                    wordBreak: "break-word",
                },
                "& th": {
                    backgroundColor: "#f0f0f0",
                    fontWeight: 700,
                    textAlign: "left",
                },
                "@media print": { border: "none", p: 0 },
            }}
        >
            <section>
                <table aria-label="document-test-team">
                    <thead>
                        <tr>
                            <th style={{ minWidth: 45, width: 45, textAlign: "center" }}>{t.lp}</th>
                            <th style={{ width: "22%" }}>{t.name}</th>
                            <th style={{ width: "18%" }}>{t.position}</th>
                            <th style={{ width: "16%" }}>{t.role}</th>
                            <th style={{ width: "22%" }}>{t.email}</th>
                            <th style={{ width: "22%" }}>{t.company}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {hasRows ? (
                            team.map((m, idx) => (
                                <tr key={m.id ?? idx}>
                                    <td style={{ width: 45, textAlign: "right" }}>
                                        {idx + 1}
                                    </td>
                                    <td>{m.name}</td>
                                    <td>{m.position}</td>
                                    <td>{roleToLabel(m.role, lang)}</td>
                                    <td>{m.email}</td>
                                    <td>{m.companyName}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan={6}
                                    style={{
                                        fontStyle: "italic",
                                        color: "#777",
                                        textAlign: "center",
                                    }}
                                >
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </section>
        </Box>
    );
};
